export * from './createWholeWordRegEx';
